export default __webpack_public_path__ + "static/media/familles-equipment.2a8f329c.svg";